import { useEffect, useState } from 'react';

const colorMappings = {
    primary: "blue",
    secondary: "zinc",
    danger: "red",
    success: "green",
}
const TwCheck = ({ checked, label, onChange, onKeyDown, defaultValue, size, placeholder, inputProps, direction }) => {
    const cssClass = [
        // "mb-4"
    ]
    if (direction != "ltr") {
        cssClass.push("rtl")
    }
    const [controlId, setControlId] = useState("Ctrl" + Math.random().toString())
    useEffect(() => {

    }, [])
    return <div className={cssClass.join(" ")}>
        <div className="relative flex items-center">
            <div className="flex h-8 items-center">
                <input checked={checked} id={controlId} onChange={onChange} name={controlId} type="checkbox" className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
            </div>
            <div className="ms-2 text-sm leading-6">
                <label htmlFor={controlId} className="text-gray-900 dark:text-gray-200">{label}</label>
                {/* <p id="comments-description" className="text-gray-500">Get notified when someones posts a comment on a posting.</p> */}
            </div>
        </div>
    </div>;
};

export default TwCheck;
